import { excelParadasState, excelParadasMutations, excelParadasActions } from "./paradaExcel";
import { enviosParadaState, enviosParadaMutations, enviosParadaActions } from "./paradaEnvios";
import { paradaService, estadosParadasService } from "@/_services";

export const parada = {
  namespaced: true,
  state: {
    ...excelParadasState(),
    ...enviosParadaState(),
    list: {
      requestId: 0,
      data: [],
      status: {},
    },
    etiqueta: {
      data: null,
      status: {},
    },
    email: {
      data: {},
      status: {},
    },
    newEventoParada: {
      requestId: 0,
      paradaId: null,
      data: null,
      status: {},
    },
    eventosDisponibles: {
      requestId: 0,
      data: [],
      status: {},
    },
    estados: {
      requestId: 0,
      data: [],
      status: {},
    },
    images: {
      data: [],
      status: {},
    },
    justificante: {
      data: null,
      status: {},
    },
    paradaId: {
      data: null,
      status: {},
    },
    payload: {
      data: null,
      status: {},
    },
  },
  mutations: {
    ...excelParadasMutations,
    ...enviosParadaMutations,
    getParadaInfoRequest(state) {
      state.paradaId.status = {
        loading: true,
      };
    },
    getParadaInfoError(state, error) {
      state.paradaId.data = [];
      state.paradaId.status = {
        error,
      };
    },
    getParadaInfoSuccess(state, response) {
      state.paradaId.data = response;
      state.paradaId.status = {
        loaded: true,
      };
    },

    getParadasRequest(state) {
      state.list.requestId += 1;
      state.list.status = {
        loading: true,
      };
    },
    getParadasError(state, error) {
      state.list.data = [];
      state.list.status = {
        error,
      };
    },
    getParadasSuccess(state, response) {
      state.list.data = response;
      state.list.status = {
        loaded: true,
      };
    },
    getEtiquetaPDFByParadaRequest(state) {
      state.etiqueta.status = {
        loading: true,
      };
    },
    getEtiquetaPDFByParadaError(state, error) {
      state.etiqueta.data = [];
      state.etiqueta.status = {
        error,
      };
    },
    getEtiquetaPDFByParadaSuccess(state, response) {
      state.etiqueta.data = response;
      state.etiqueta.status = {
        loaded: true,
      };
    },
    sendEmailEtiquetasByParadaRequest(state) {
      state.email.status = {
        sending: true,
      };
    },
    sendEmailEtiquetasByParadaError(state, error) {
      state.email.data = [];
      state.email.status = {
        error,
      };
    },
    sendEmailEtiquetasByParadaSuccess(state, response) {
      state.email.data = response;
      state.email.status = {
        sended: true,
      };
    },
    newEventoParadaRequest(state, paradaId) {
      state.newEventoParada.requestId += 1;
      state.newEventoParada.paradaId = paradaId;
      state.newEventoParada.data = null;
      state.newEventoParada.status = {
        creating: true,
      };
    },
    newEventoParadaError(state, error) {
      state.newEventoParada.data = null;
      state.newEventoParada.status = {
        error,
      };
    },
    newEventoParadaSuccess(state, response) {
      state.newEventoParada.data = response;
      state.newEventoParada.status = {
        created: true,
      };
    },
    resetEventoParada(state) {
      state.newEventoParada.requestId += 1;
      state.newEventoParada.paradaId = null;
      state.newEventoParada.data = null;
      state.newEventoParada.status = {};
      state.eventosDisponibles.requestId += 1;
      state.eventosDisponibles.data = [];
      state.eventosDisponibles.status = {};
    },
    getEventosDisponiblesRequest(state) {
      state.eventosDisponibles.requestId += 1;
      state.eventosDisponibles.data = [];
      state.eventosDisponibles.status = { loading: true };
    },
    getEventosDisponiblesSuccess(state, response) {
      state.eventosDisponibles.data = response.items || [];
      state.eventosDisponibles.status = { loaded: true };
    },
    getEventosDisponiblesError(state, error) {
      state.eventosDisponibles.data = [];
      state.eventosDisponibles.status = { error };
    },
    getEstadosParadaRequest(state) {
      state.estados.requestId += 1;
      state.estados.status = {
        loading: true,
      };
    },
    getEstadosParadaError(state, error) {
      state.estados.data = [];
      state.estados.status = {
        error,
      };
    },
    getEstadosParadaSuccess(state, response) {
      state.estados.data = response;
      state.estados.status = {
        loaded: true,
      };
    },
    getImagesRequest(state) {
      state.images.status = {
        loading: true,
      };
    },
    getImagesError(state, error) {
      state.images.data = [];
      state.images.status = {
        error,
      };
    },
    getImagesSuccess(state, response) {
      state.images.data = response;
      state.images.status = {
        loaded: true,
      };
    },
    getJustificantePDFByParadaRequest(state) {
      state.justificante.status = {
        loading: true,
      };
    },
    getJustificantePDFByParadaError(state, error) {
      state.justificante.data = [];
      state.justificante.status = {
        error,
      };
    },
    getJustificantePDFByParadaSuccess(state, response) {
      state.justificante.data = response;
      state.justificante.status = {
        loaded: true,
      };
    },
    getPayloadRequest(state) {
      state.payload.status = {
        downloading: true,
      };
    },
    getPayloadSuccess(state, payload) {
      state.payload.data = payload;
      state.payload.status = {
        downloaded: true,
      };
    },
    getPayloadError(state, error) {
      state.payload.data = null;
      state.payload.status = {
        error,
      };
    },
  },
  actions: {
    ...excelParadasActions(() => paradaService),
    ...enviosParadaActions,
    getParadas({ state, commit }, request) {
      commit("getParadasRequest");
      const requestId = state.list.requestId;
      paradaService
        .getParadas(request.pagination, request.filters)
        .then((response) => {
          if (requestId === state.list.requestId) commit("getParadasSuccess", response);
        })
        .catch((error) => {
          if (requestId === state.list.requestId) commit("getParadasError", error);
        });
    },
    getParadaInfo({ commit }, masivoId) {
      commit("getParadaInfoRequest");
      paradaService
        .getParada(masivoId)
        .then((response) => {
          commit("getParadaInfoSuccess", response);
        })
        .catch((error) => {
          commit("getParadaInfoError", error);
        });
    },
    getEtiquetaPDFByParada({ commit }, idParada) {
      commit("getEtiquetaPDFByParadaRequest");
      paradaService
        .getEtiquetaPDFByParada(idParada)
        .then((response) => {
          commit("getEtiquetaPDFByParadaSuccess", response);
        })
        .catch((error) => {
          commit("getEtiquetaPDFByParadaError", error);
        });
    },
    sendEmailEtiquetasByParada({ commit }, idParada) {
      commit("sendEmailEtiquetasByParadaRequest");
      paradaService
        .sendEmailEtiquetasByParada(idParada)
        .then((response) => {
          commit("sendEmailEtiquetasByParadaSuccess", response);
        })
        .catch((error) => {
          commit("sendEmailEtiquetasByParadaError", error);
        });
    },
    newEventoParada({ state, commit }, request) {
      if (state.newEventoParada.status.creating) return;
      commit("newEventoParadaRequest", request._id);
      const requestId = state.newEventoParada.requestId;
      paradaService
        .newEventoParada(request._id, request.body)
        .then((response) => {
          if (requestId === state.newEventoParada.requestId) commit("newEventoParadaSuccess", response);
        })
        .catch((error) => {
          if (requestId === state.newEventoParada.requestId) commit("newEventoParadaError", error);
        });
    },
    resetEventoParada({ commit }) {
      commit("resetEventoParada");
    },
    getEventosDisponibles({ state, commit }) {
      if (state.eventosDisponibles.status.loading) return;
      commit("getEventosDisponiblesRequest");
      const requestId = state.eventosDisponibles.requestId;
      estadosParadasService.getEstados(null, {})
        .then((response) => {
          if (requestId === state.eventosDisponibles.requestId) commit("getEventosDisponiblesSuccess", response);
        })
        .catch((error) => {
          if (requestId === state.eventosDisponibles.requestId) commit("getEventosDisponiblesError", error);
        });
    },
    getEstadosParada({ state, commit }, idParada) {
      commit("getEstadosParadaRequest");
      const requestId = state.estados.requestId;
      paradaService
        .estadosParada(idParada)
        .then((response) => {
          if (requestId === state.estados.requestId) commit("getEstadosParadaSuccess", response);
        })
        .catch((error) => {
          if (requestId === state.estados.requestId) commit("getEstadosParadaError", error);
        });
    },
    getImages({ commit }, id) {
      commit("getImagesRequest");
      paradaService
        .getImages(id)
        .then((response) => {
          commit("getImagesSuccess", response);
        })
        .catch((error) => {
          commit("getImagesError", error);
        });
    },
    getJustificantePDFByParada({ commit }, idParada) {
      commit("getJustificantePDFByParadaRequest");
      paradaService
        .getJustificantePDFByParada(idParada)
        .then((response) => {
          commit("getJustificantePDFByParadaSuccess", response);
        })
        .catch((error) => {
          commit("getJustificantePDFByParadaError", error);
        });
    },
    getPayload({ commit }, idParada) {
      commit("getPayloadRequest");
      paradaService
        .getPayload(idParada)
        .then((file) => {
          commit("getPayloadSuccess", file);
        })
        .catch((error) => {
          commit("getPayloadError", error);
        });
    },
  },
};
